import { mixins, styled } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'

export const ProductImage = styled(Asset)`
  width: 100%;
`

export const Wrapper = styled.a`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  & > * {
    pointer-events: none;
  }
  cursor: pointer;

  ${mixins.margin(5)};
  width: 100%;
  ${mixins.media.min.tablet} {
    width: calc(50% - 10px);
  }
  ${mixins.media.min.desktop} {
    width: calc(25% - 10px);
  }
  ${mixins.padding.bottom(10)};
  position: relative;
  ${mixins.shadows.flatNear};
  transition: 0.25s;
  &:hover {
    ${mixins.shadows.floating};
  }
`

export const TextWrapper = styled.div`
  ${mixins.padding(25)}
  ${mixins.margin.bottom('auto')}
`

export const Title = styled.h2`
  ${mixins.typography.headlineXs}
  ${mixins.margin.top(0)}
  ${mixins.margin.bottom(30)}
`

export const Description = styled.p`
  ${mixins.typography.paragraphSmall}
`
export const ButtonTertiary = styled.button`
  ${mixins.cta.tertiary('blue')}
`
